import * as React from 'react';

import * as Sentry from '@sentry/react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType
} from 'react-router-dom';

import { getConfig } from '@/features/environment/config';

const useSentry = (): void => {
  const envConfig = getConfig();

  Sentry.init({
    dsn: envConfig?.SENTRY_DSN,
    environment: envConfig?.SENTRY_ENVIRONMENT,
    enabled: !envConfig?.IsLocal,
    release: envConfig?.SENTRY_RELEASE,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes
      })
    ],
    tracesSampleRate: envConfig?.APP_ENVIRONMENT === 'production' ? 0.2 : 1.0,
    replaysSessionSampleRate: envConfig?.APP_ENVIRONMENT === 'production' ? 0.1 : 0.5,
    replaysOnErrorSampleRate: 1.0,
    ignoreErrors: [
      'chrome-extension://',
      'moz-extension://',
      'safari-extension://',
      "Cannot read properties of undefined (reading 'has')",
      /^Object captured as promise rejection with keys: /,
      'invalid origin' // App Insights cross-origin postMessage blocked by privacy browsers (#29855)
    ],
    denyUrls: [
      /extensions\//i,
      /^chrome:\/\//i,
      /^chrome-extension:\/\//i,
      /^moz-extension:\/\//i,
      /^safari-extension:\/\//i
    ],
    beforeSend(event, _hint) {
      // Site24x7 bot generates false positives that don't affect real users
      const userAgent = event.request?.headers?.['User-Agent'];
      if (userAgent?.includes('Site24x7')) {
        return null;
      }
      return event;
    }
  });

  Sentry.setTag('service', envConfig?.SENTRY_SERVICE_TAG);
};

export { useSentry };
